/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTROL BAR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	controlbar: {
		display: 'flex',
		justifyContent: 'space-between',

		// ----- searchbar ----- //
		'& .searchbar': {
			maxWidth: pxToEm(457),
			marginRight: pxToEm(20),
			width: '100%'
		},

		// ----- filters ----- //
		'& .name-filters': {
			marginBottom: pxToEm(30),
			display: 'flex',
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
			alignItems: 'center',
			'& .filter': {
				flex: '1',
				marginRight: pxToEm(10),
				'&:nth-child(1)': {zIndex: '13'},
				'&:nth-child(2)': {zIndex: '12', justifySelf: 'flex-end'},
				'&:nth-child(3)': {zIndex: '11', justifySelf: 'flex-end'}
			},
			'& .text': {
				marginRight: pxToEm(15)
			}
		}
	},
	[mediaQuery.thinnest]: {
		controlbar: {
			flexDirection: 'column',
			'& .searchbar': {
				maxWidth: '100% !important',
				width: '100%',
				marginBottom: pxToEm(15)
			},
			'& .name-filters': {
				justifyContent: 'flex-start',
				'& .text': {
					width: '100%',
					marginBottom: pxToEm(15)
				}
			}
		}
	}
});